export default "__VITE_ASSET__DbFxSadC__"